import React from 'react';
import cx from './cx';

const SIZE_CLASS = {
  sm: 'rg-layout-container--sm',
  md: 'rg-layout-container--md',
  lg: 'rg-layout-container--lg',
  xl: 'rg-layout-container--xl',
  fluid: 'rg-layout-container--fluid'
};

function LayoutContainer({
  as: Component = 'div',
  size = 'lg',
  className,
  children,
  ...props
}) {
  return (
    <Component
      className={cx(
        'rg-layout-container',
        SIZE_CLASS[size] || SIZE_CLASS.lg,
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}

export default LayoutContainer;
